var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanama(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h39v24H0V0z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12h19.5v12H0V12z",
    fill: "#005293"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0H39v12H19.5V0z",
    fill: "#D21034"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66 5.073l1.91 1.281-.73 2.073 1.91-1.281 1.91 1.281-.73-2.073 1.91-1.281h-2.36L9.75 3l-.73 2.073H6.66z",
    fill: "#005293"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.16 17.073l1.91 1.281-.73 2.073 1.91-1.281 1.91 1.281-.73-2.073 1.91-1.281h-2.36L29.25 15l-.73 2.073h-2.36z",
    fill: "#D21034"
  })));
}
export default __webpack_public_path__ + "static/media/panama.413d1cbd.svg";
export { SvgPanama as ReactComponent };